module.exports = __webpack_public_path__ + "static/media/apple.362459d9.svg";